<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm">
          <el-form-item label="发起日期">
            <form-date-range :form="searchForm" startKey="startDate" endKey="endDate" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
          </el-form-item>
          <el-form-item label="缺货流程号">
            <el-input v-model.trim="searchForm.workflowNo" placeholder="请输入缺货跟进流程号" />
          </el-form-item>
          <el-form-item label="总进度状态">
            <el-select v-model="searchForm.allCompleteStatus" clearable>
              <el-option label="进行中" value="进行中" />
              <el-option label="已完成(准时)" value="已完成(准时)" />
              <el-option label="已完成(逾期)" value="已完成(逾期)" />
              <el-option label="逾期未完成" value="逾期未完成" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <el-table
        :data="tableData.list"
        border
        stripe
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :height="maxTableHeight"
      >
        <el-table-column prop="workflowNo" label="缺货跟进流程号" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createdDate" label="发起时间" min-width="160" />
        <el-table-column prop="packCommitDate" label="回复时间" min-width="160" />
        <el-table-column prop="oosPackNum" label="缺货包件总量" min-width="120" />
        <el-table-column prop="mustReplyOosDemand" label="紧急缺货量" min-width="120" />
        <el-table-column prop="actualOfflineNum" label="截至今日实际下线入库量" min-width="170" />
        <el-table-column prop="todayOfflineCompleteRate" label="截至今日完成进度" min-width="150" />
        <el-table-column prop="allOfflineCompleteRate" label="总完成进度" min-width="120" />
        <el-table-column prop="allCompleteStatus" label="总进度状态" min-width="130" />
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openDetail(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';

export default {
  name: 'LackPackagesSummary',
  mixins: [pagePathMixin, tableMixin],
  data () {
    return {
      loading: false,
      searchForm: {
        startDate: '',
        endDate: '',
        workflowNo: '',
        allCompleteStatus: ''
      },
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.loading = true
      this.$q.orderDate.workflowInfoSelectListByPage({
        data: {
          pageNum: this.tableData.pageNum,
          pageSize: this.tableData.pageSize,
          filterData: this.searchForm
        }
      }).then((res) => {
        const data = res.data || {}
        this.tableData = {
          ...this.tableData,
          list: data.list || [],
          total: data.total || 0,
          pageNum: data.pageNum || this.tableData.pageNum,
          pageSize: data.pageSize || this.tableData.pageSize
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch () {
      this.tableData.pageNum = 1
      this.init()
    },
    onReset () {
      this.searchForm = {
        startDate: '',
        endDate: '',
        workflowNo: '',
        allCompleteStatus: ''
      }
      this.onSearch()
    },
    handleSizeChange (val) {
      this.tableData.pageSize = val
      this.tableData.pageNum = 1
      this.init()
    },
    handleCurrentChange (val) {
      this.tableData.pageNum = val
      this.init()
    },
    openDetail (row) {
      this.openSubPage({
        path: '/lackPackagesDetails',
        query: {
          workflowNo: row.workflowNo,
          createdDate: row.createdDate,
          packCommitDate: row.packCommitDate
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-select,
  >>> .el-input
    width 220px !important

>>> .date-range .single-date
  width 110px !important
</style>
